// @ts-nocheck
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import Page from '../../components/library/Page';
import Title from '../../components/library/Title';
import ConstantValues from '../../constants/ConstantValues';
import { SEO } from '../../common';
import { formatSEOTitle } from '../../function';
import { useTranslation } from 'react-i18next';

function StickerGuide(){
  const { t } = useTranslation();

  useEffect(() => {
    if (document.location.hostname === ConstantValues.SiteHostname) { 
      ReactGA.pageview(window.location.pathname);
    }
  },[]);

  const Content = () => {
    return(
      <>
        <Title type="sub" title={t('sticker_guide_what_are_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('sticker_guide_why_use_description')}
        </Typography>
        <ul style={{marginLeft: '20px', marginBottom: '20px'}}>
          <li><Typography variant="body1">{t('sticker_guide_advantage_1')}</Typography></li>
          <li><Typography variant="body1">{t('sticker_guide_advantage_2')}</Typography></li>
          <li><Typography variant="body1">{t('sticker_guide_advantage_3')}</Typography></li>
          <li><Typography variant="body1">{t('sticker_guide_advantage_4')}</Typography></li>
        </ul>

        <Title type="sub" title={t('sticker_guide_best_practices_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '10px'}}>
          {t('sticker_guide_best_practices_description')}
        </Typography>
        
        <Grid container spacing={2} style={{marginBottom: '20px'}}>
          <Grid item xs={12} md={6}>
            <Paper elevation={2} style={{padding: '15px'}}>
              <Typography variant="h6" gutterBottom>{t('sticker_guide_image_quality_title')}</Typography>
              <ul>
                <li><Typography variant="body2">{t('sticker_guide_image_quality_1')}</Typography></li>
                <li><Typography variant="body2">{t('sticker_guide_image_quality_2')}</Typography></li>
                <li><Typography variant="body2">{t('sticker_guide_image_quality_3')}</Typography></li>
              </ul>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={2} style={{padding: '15px'}}>
              <Typography variant="h6" gutterBottom>{t('sticker_guide_design_principles_title')}</Typography>
              <ul>
                <li><Typography variant="body2">{t('sticker_guide_design_principles_1')}</Typography></li>
                <li><Typography variant="body2">{t('sticker_guide_design_principles_2')}</Typography></li>
                <li><Typography variant="body2">{t('sticker_guide_design_principles_3')}</Typography></li>
              </ul>
            </Paper>
          </Grid>
        </Grid>

        <Title type="sub" title={t('sticker_guide_formats_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '15px'}}>
          {t('sticker_guide_formats_description')}
        </Typography>

        <Grid container spacing={2} style={{marginBottom: '20px'}}>
          <Grid item xs={12} sm={6} md={3}>
            <Paper elevation={2} style={{padding: '15px', height: '100%'}}>
              <Typography variant="h6" color="primary" gutterBottom>{t('sticker_guide_png_title')}</Typography>
              <Typography variant="body2" gutterBottom><strong>{t('sticker_guide_png_best_for')}</strong></Typography>
              <Typography variant="body2" gutterBottom><strong>{t('sticker_guide_png_advantages')}</strong></Typography>
              <Typography variant="body2"><strong>{t('sticker_guide_png_file_size')}</strong></Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper elevation={2} style={{padding: '15px', height: '100%'}}>
              <Typography variant="h6" color="primary" gutterBottom>{t('sticker_guide_webp_title')}</Typography>
              <Typography variant="body2" gutterBottom><strong>{t('sticker_guide_webp_best_for')}</strong></Typography>
              <Typography variant="body2" gutterBottom><strong>{t('sticker_guide_webp_advantages')}</strong></Typography>
              <Typography variant="body2"><strong>{t('sticker_guide_webp_file_size')}</strong></Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper elevation={2} style={{padding: '15px', height: '100%'}}>
              <Typography variant="h6" color="primary" gutterBottom>{t('sticker_guide_jpeg_title')}</Typography>
              <Typography variant="body2" gutterBottom><strong>{t('sticker_guide_jpeg_best_for')}</strong></Typography>
              <Typography variant="body2" gutterBottom><strong>{t('sticker_guide_jpeg_advantages')}</strong></Typography>
              <Typography variant="body2"><strong>{t('sticker_guide_jpeg_limitations')}</strong></Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper elevation={2} style={{padding: '15px', height: '100%'}}>
              <Typography variant="h6" color="primary" gutterBottom>{t('sticker_guide_gif_title')}</Typography>
              <Typography variant="body2" gutterBottom><strong>{t('sticker_guide_gif_best_for')}</strong></Typography>
              <Typography variant="body2" gutterBottom><strong>{t('sticker_guide_gif_advantages')}</strong></Typography>
              <Typography variant="body2"><strong>{t('sticker_guide_gif_limitations')}</strong></Typography>
            </Paper>
          </Grid>
        </Grid>

        <p className="MuiTypography-root MuiTypography-body1 css-1jm64c3-MuiTypography-root" style={{marginTop: '48px'}}>{t('sticker_guide_how_to_title')}</p>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '15px'}}>
          {t('sticker_guide_how_to_description')}
        </Typography>

        <ol style={{marginLeft: '20px', marginBottom: '20px'}}>
          <li style={{marginBottom: '10px'}}>
            <Typography variant="body1"><strong>{t('sticker_guide_step_1')}</strong></Typography>
          </li>
          <li style={{marginBottom: '10px'}}>
            <Typography variant="body1"><strong>{t('sticker_guide_step_2')}</strong></Typography>
          </li>
          <li style={{marginBottom: '10px'}}>
            <Typography variant="body1"><strong>{t('sticker_guide_step_3')}</strong></Typography>
          </li>
          <li style={{marginBottom: '10px'}}>
            <Typography variant="body1"><strong>{t('sticker_guide_step_4')}</strong></Typography>
          </li>
          <li style={{marginBottom: '10px'}}>
            <Typography variant="body1"><strong>{t('sticker_guide_step_5')}</strong></Typography>
          </li>
          <li style={{marginBottom: '10px'}}>
            <Typography variant="body1"><strong>{t('sticker_guide_step_6')}</strong></Typography>
          </li>
        </ol>

        <Divider style={{margin: '30px 0'}} />

        <Title type="sub" title={t('sticker_guide_advanced_tips_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '15px'}}>
          {t('sticker_guide_advanced_tips_description')}
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Paper elevation={2} style={{padding: '20px'}}>
              <Typography variant="h6" gutterBottom color="secondary">{t('sticker_guide_consistency_title')}</Typography>
              <Typography variant="body2">
                {t('sticker_guide_consistency_description')}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={2} style={{padding: '20px'}}>
              <Typography variant="h6" gutterBottom color="secondary">{t('sticker_guide_emotional_range_title')}</Typography>
              <Typography variant="body2">
                {t('sticker_guide_emotional_range_description')}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={2} style={{padding: '20px'}}>
              <Typography variant="h6" gutterBottom color="secondary">{t('sticker_guide_test_others_title')}</Typography>
              <Typography variant="body2">
                {t('sticker_guide_test_others_description')}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <div style={{marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px'}}>
          <Typography variant="h6" gutterBottom>{t('sticker_guide_ready_title')}</Typography>
          <Typography variant="body1">
            {t('sticker_guide_ready_description')}
          </Typography>
        </div>
      </>
    );
  };

  return(
    <Page pageTitle={t('sticker_guide_page_title')}>
      <SEO
        title={formatSEOTitle(t('sticker_guide_page_title') + ' | Signal Sticker Maker')}
        description='Learn how to make custom stickers for Signal messaging app. Complete guide to creating personalized sticker packs with our free Signal sticker maker tool. Step-by-step instructions included.'
      />
      <Content/>
    </Page>
  );
}

export default StickerGuide;
